import { IconArrowLeftBold, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

interface Props {
  label: string;
  onClose: () => void;
}

export const Header = ({ label, onClose }: Props) => {
  return (
    <Container>
      <BackButton onClick={onClose}>
        <IconArrowLeftBold size={30} />
      </BackButton>
      <Text variant='Body_17_Bold'>{label}</Text>
    </Container>
  );
};

const Container = styled.div`
  margin: 0 16px 20px 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
`;

const BackButton = styled.button`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;
